import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useIdCopy } from "@hooks/useIdCopy";
import { JournalEntryListRow } from "../views/journalEntryListViewConfig";

export const JournalEntryReferenceCell: React.FC<
    CellContext<ViewTableFeatures, JournalEntryListRow, string>
> = React.memo(({ row, getValue }) => {
    const { getCopyProps } = useIdCopy({ label: "Journal Entry" });

    return (
        <ViewTableCell>
            <span {...getCopyProps(row.original.id)}>{getValue()}</span>
        </ViewTableCell>
    );
});

JournalEntryReferenceCell.displayName = "JournalEntryReferenceCell";
